/**
 * Hook for dynamic client logo loading.
 *
 * Returns logo path for a client config and handles missing logos gracefully.
 */

import { useMemo } from "react";
import { getClientById } from "../config/retailerConfig";
import { getClientLogo } from "../config/logoConfig";

interface UseClientLogoResult {
  logoPath: string | null;
  logoAlt: string;
  clientName: string;
}

export function useClientLogo(clientId: string | null): UseClientLogoResult {
  return useMemo(() => {
    if (!clientId) {
      return {
        logoPath: null,
        logoAlt: "Client Logo",
        clientName: "Unknown Client",
      };
    }

    const client = getClientById(clientId);
    if (!client) {
      return {
        logoPath: null,
        logoAlt: "Client Logo",
        clientName: clientId,
      };
    }

    const logoPath = getClientLogo(client.logoFile);

    return {
      logoPath,
      logoAlt: `${client.name} Logo`,
      clientName: client.name,
    };
  }, [clientId]);
}
